import React from 'react';
import { Modal } from 'react-responsive-modal';

const ActivityAddModel = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal1' }}
    >
      <div className="d-flex justify-content-between align-items-center p-2">
        <h6>Add Time</h6>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="p-2">
        <div className="form-group mt-1">
          <label for="username1" className="font-14 text-muted ">
            Nov 8, 2024
          </label>
          <select className="form-control">
            <option>Project 1</option>
            <option value="true">Project 2</option>
            <option value="false">Project 3</option>
          </select>
        </div>

        <select className="form-control mt-1">
          <option>Select task</option>
          <option value="true">Team-wide</option>
          <option value="false">Custom</option>
        </select>

        <div className="d-flex align-items-center mt-3" style={{ gap: '10px' }}>
          <input type="time" className="form-control" />
          <i className="dripicons-clock"></i>
          <input type="time" className="form-control" />
        </div>

        <select className="form-control mt-3">
          <option>Activity Description</option>
          <option value="true">No</option>
        </select>
      </div>

      <div className="modal-footer d-flex justify-content-center align-items-center mt-2">
        <button type="button" className="btn btn-purple">
          Add
        </button>
      </div>
    </Modal>
  );
};

export default ActivityAddModel;
